import script from "./ToolBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolBar.vue?vue&type=script&setup=true&lang=ts"

import "./ToolBar.vue?vue&type=style&index=0&id=12f119e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12f119e4"]])

export default __exports__